import { render } from "./error-log.vue?vue&type=template&id=196c9d9d&scoped=true"
import script from "./error-log.vue?vue&type=script&lang=js"
export * from "./error-log.vue?vue&type=script&lang=js"

import "./error-log.vue?vue&type=style&index=0&id=196c9d9d&scoped=true&lang=css"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196c9d9d"]])

export default __exports__